import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { AccountProfileProps } from "./types";

export class AccountProfileDefinitions extends CmsReactComponent<AccountProfileProps> {
    static defaultProps = {};

    static schemaName = "account-profile";

    static propertyDefinitions: PropertyDefinition[] = [{
        name: "title",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Başlık",
    },
    {
        name: "description",
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        text: "Açıklama",
    },];
}
